import { render } from "./receiverConfig.vue?vue&type=template&id=7a6f8252"
import script from "./receiverConfig.vue?vue&type=script&lang=js"
export * from "./receiverConfig.vue?vue&type=script&lang=js"

import "./receiverConfig.vue?vue&type=style&index=0&id=7a6f8252&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__